module.exports = __webpack_public_path__ + "media/Great_Great_Grandfather.b8ce7b9a.mp3";